import { api } from '../api/client';
import type { Order } from '../api/types';
import { trackPedidoEnviado } from './tracking';

/**
 * Abre uma aba em branco para o WhatsApp, dentro do clique.
 *
 * Sem 'noopener' de propósito: é preciso a referência da aba para mandar o
 * endereço depois. O opener é cortado logo em seguida, que é o que o noopener
 * protegeria. Se o navegador recusar, devolve null e a tela do pedido oferece
 * abrir a conversa por um botão.
 */
export function abrirAbaEmBranco(): Window | null {
  try {
    const aba = window.open('', '_blank');
    if (aba) {
      aba.opener = null;
      // A aba fica aberta um instante enquanto o pedido é criado; em branco,
      // parece que travou.
      aba.document.title = 'Abrindo o WhatsApp…';
      aba.document.body.style.cssText = 'background:#0e1116;color:#e6edf3;font:16px system-ui;display:grid;place-items:center;height:100vh;margin:0';
      aba.document.body.textContent = 'Abrindo o WhatsApp do atendimento…';
    }
    return aba;
  } catch {
    return null;
  }
}

/**
 * Manda o pedido recém-criado ao atendimento e abre o WhatsApp.
 *
 * Usado por todo fechamento (sacola, upgrade e venda de inventário): o pedido
 * nasce e já chega ao painel como enviado, sem depender de um segundo clique
 * na tela do pedido. A aba já vem aberta do clique (ver abrirAbaEmBranco).
 *
 * Se o envio falhar, o pedido existe mesmo assim e a tela dele oferece enviar
 * de novo — por isso a função não lança: quem chama segue para a tela do
 * pedido de qualquer jeito.
 */
export async function enviarAoAtendimento(order: Order, aba: Window | null): Promise<void> {
  try {
    const res = await api.enviarPedido(order.code);
    // Conversão só com o servidor confirmando o envio.
    trackPedidoEnviado(order);
    if (res.whatsapp && aba) aba.location.href = res.whatsapp;
    else aba?.close();
  } catch {
    aba?.close();
  }
}
